import React from "react";
import { useParams } from "react-router-dom";
import SEO from "./SEO";

import PhoneCaptureForm from "./funnel/PhoneCaptureForm";
import TrustStrip from "./funnel/TrustStrip";
import StatsBlock from "./funnel/StatsBlock";
import ScreenshotCarousel from "./funnel/ScreenshotCarousel";
import KunjiHighlight from "./funnel/KunjiHighlight";
import PricingBlock from "./funnel/PricingBlock";
import TopperGrid from "./funnel/TopperGrid";
import FAQ from "./funnel/FAQ";
import { buildPlayStoreUrl } from "./funnel/utm";
import PlayStoreCTA from "./funnel/PlayStoreCTA";

const boardData = {
  "bihar-board": {
    name: "बिहार बोर्ड (BSEB)",
    fullName: "Bihar School Examination Board",
    shortCode: "BSEB",
    title: "बिहार बोर्ड परीक्षा तैयारी - BSEB Class 6-12 | Pathyacharya App",
    description:
      "बिहार बोर्ड (BSEB) परीक्षा की तैयारी हिंदी में करें। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
      "संस्कृत",
    ],
    highlights: [
      "बिहार बोर्ड टॉपर्स ने Pathyacharya से पढ़ाई की",
      "BSEB syllabus के अनुसार video lectures",
      "पिछले वर्षों के प्रश्न पत्र और solutions",
    ],
  },
  "up-board": {
    name: "UP बोर्ड (UPMSP)",
    fullName: "Uttar Pradesh Madhyamik Shiksha Parishad",
    shortCode: "UPMSP",
    title: "UP बोर्ड परीक्षा तैयारी - UPMSP Class 6-12 | Pathyacharya App",
    description:
      "UP बोर्ड (UPMSP) परीक्षा की तैयारी हिंदी में करें। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
      "संस्कृत",
    ],
    highlights: [
      "UP बोर्ड syllabus के अनुसार content",
      "UPMSP परीक्षा pattern के अनुसार practice",
      "हिंदी माध्यम में सभी विषय",
    ],
  },
  "mp-board": {
    name: "MP बोर्ड (MPBSE)",
    fullName: "Madhya Pradesh Board of Secondary Education",
    shortCode: "MPBSE",
    title: "MP बोर्ड परीक्षा तैयारी - MPBSE Class 6-12 | Pathyacharya App",
    description:
      "MP बोर्ड (MPBSE) परीक्षा की तैयारी हिंदी में करें। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
    ],
    highlights: [
      "MPBSE syllabus के अनुसार video lectures",
      "MP बोर्ड टॉपर्स की success stories",
      "हिंदी माध्यम में पूरा course",
    ],
  },
  "jharkhand-board": {
    name: "झारखंड बोर्ड (JAC)",
    fullName: "Jharkhand Academic Council",
    shortCode: "JAC",
    title:
      "झारखंड बोर्ड परीक्षा तैयारी - JAC Class 6-12 | Pathyacharya App",
    description:
      "झारखंड बोर्ड (JAC) परीक्षा की तैयारी हिंदी में करें। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
    ],
    highlights: [
      "JAC syllabus के अनुसार content",
      "झारखंड बोर्ड टॉपर्स ने Pathyacharya से पढ़ाई की",
      "Block level rank holders हमारे students हैं",
    ],
  },
  "rajasthan-board": {
    name: "राजस्थान बोर्ड (RBSE)",
    fullName: "Rajasthan Board of Secondary Education",
    shortCode: "RBSE",
    title:
      "राजस्थान बोर्ड परीक्षा तैयारी - RBSE Class 6-12 | Pathyacharya App",
    description:
      "राजस्थान बोर्ड (RBSE) परीक्षा की तैयारी हिंदी में करें। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
    ],
    highlights: [
      "RBSE syllabus के अनुसार video lectures",
      "राजस्थान बोर्ड परीक्षा pattern पर आधारित",
      "हिंदी माध्यम में सभी विषय",
    ],
  },
  "chhattisgarh-board": {
    name: "छत्तीसगढ़ बोर्ड (CGBSE)",
    fullName: "Chhattisgarh Board of Secondary Education",
    shortCode: "CGBSE",
    title:
      "छत्तीसगढ़ बोर्ड परीक्षा तैयारी - CGBSE Class 6-12 | Pathyacharya App",
    description:
      "छत्तीसगढ़ बोर्ड (CGBSE) परीक्षा की तैयारी हिंदी में करें। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
    ],
    highlights: [
      "CGBSE syllabus के अनुसार content",
      "छत्तीसगढ़ बोर्ड परीक्षा के लिए तैयारी",
      "हिंदी माध्यम में पूरा course",
    ],
  },
  "uttarakhand-board": {
    name: "उत्तराखंड बोर्ड (UBSE)",
    fullName: "Uttarakhand Board of School Education",
    shortCode: "UBSE",
    title:
      "उत्तराखंड बोर्ड परीक्षा तैयारी - UBSE Class 6-12 | Pathyacharya App",
    description:
      "उत्तराखंड बोर्ड (UBSE) परीक्षा की तैयारी हिंदी में करें। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
    ],
    highlights: [
      "UBSE syllabus के अनुसार video lectures",
      "उत्तराखंड बोर्ड परीक्षा pattern पर आधारित",
      "हिंदी माध्यम में सभी विषय",
    ],
  },
  "haryana-board": {
    name: "हरियाणा बोर्ड (HBSE)",
    fullName: "Haryana Board of School Education",
    shortCode: "HBSE",
    title:
      "हरियाणा बोर्ड परीक्षा तैयारी - HBSE Class 6-12 | Pathyacharya App",
    description:
      "हरियाणा बोर्ड (HBSE) परीक्षा की तैयारी हिंदी में करें। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
    ],
    highlights: [
      "HBSE syllabus के अनुसार content",
      "हरियाणा बोर्ड परीक्षा के लिए तैयारी",
      "हिंदी माध्यम में पूरा course",
    ],
  },
  "cbse-board": {
    name: "CBSE",
    fullName: "Central Board of Secondary Education",
    shortCode: "CBSE",
    title:
      "CBSE परीक्षा तैयारी - NCERT Class 6-12 | Pathyacharya App",
    description:
      "CBSE परीक्षा की तैयारी हिंदी में करें। NCERT-aligned video lectures, AI doubt solving, daily quizzes Class 6-12 के लिए। Pathyacharya ऐप अभी download करें!",
    classes: "Class 6 से Class 12",
    subjects: [
      "गणित (Mathematics)",
      "विज्ञान (Science)",
      "सामाजिक विज्ञान (Social Science)",
      "हिंदी",
      "अंग्रेजी (English)",
      "संस्कृत",
    ],
    highlights: [
      "NCERT पाठ्यक्रम के अनुसार video lectures",
      "CBSE board exam pattern पर आधारित practice",
      "हिंदी माध्यम में पूरा course",
    ],
  },
};

const BoardPage = () => {
  const { boardSlug } = useParams();
  const board = boardData[boardSlug];

  if (!board) {
    return (
      <div className="mt-[120px] text-center py-20">
        <h1 className="text-3xl font-bold">Page Not Found</h1>
        <p className="text-gray-600 mt-4">
          The board page you are looking for does not exist.
        </p>
      </div>
    );
  }

  const slugTag = board.shortCode.toLowerCase();
  const campaign = `board_${slugTag}`;
  const heroSource = `board_${slugTag}_hero`;
  const finalSource = `board_${slugTag}_final`;
  const heroPlayUrl = buildPlayStoreUrl({
    medium: "board_page",
    campaign,
    term: "hero",
  });
  const finalPlayUrl = buildPlayStoreUrl({
    medium: "board_page",
    campaign,
    term: "final-cta",
  });

  return (
    <div className="mt-[100px]">
      <SEO
        title={board.title}
        description={board.description}
        url={`https://schooglink.com/${boardSlug}`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          name: `Pathyacharya — ${board.shortCode}`,
          operatingSystem: "Android",
          applicationCategory: "EducationalApplication",
          offers: {
            "@type": "AggregateOffer",
            lowPrice: "99",
            highPrice: "599",
            priceCurrency: "INR",
            offerCount: 3,
            offers: [
              {
                "@type": "Offer",
                name: "Monthly Subscription",
                price: "99",
                priceCurrency: "INR",
                priceSpecification: {
                  "@type": "UnitPriceSpecification",
                  price: "99",
                  priceCurrency: "INR",
                  referenceQuantity: {
                    "@type": "QuantitativeValue",
                    value: "1",
                    unitCode: "MON",
                  },
                },
              },
              {
                "@type": "Offer",
                name: "Quarterly Subscription",
                price: "249",
                priceCurrency: "INR",
                priceSpecification: {
                  "@type": "UnitPriceSpecification",
                  price: "249",
                  priceCurrency: "INR",
                  referenceQuantity: {
                    "@type": "QuantitativeValue",
                    value: "3",
                    unitCode: "MON",
                  },
                },
              },
              {
                "@type": "Offer",
                name: "Yearly Subscription",
                price: "599",
                priceCurrency: "INR",
                priceSpecification: {
                  "@type": "UnitPriceSpecification",
                  price: "599",
                  priceCurrency: "INR",
                  referenceQuantity: {
                    "@type": "QuantitativeValue",
                    value: "1",
                    unitCode: "ANN",
                  },
                },
              },
            ],
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4.5",
            ratingCount: "1000",
          },
          description: board.description,
        }}
      />

      {/* Hero */}
      <section className="bg-gradient-to-b from-blue-50 to-white py-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block bg-yellow-100 border border-yellow-400 rounded-full px-3 py-1 mb-4">
            <p className="text-xs sm:text-sm font-bold text-yellow-800">
              7 दिन का Free Trial · No credit card
            </p>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            {board.name}
            <br />
            <span className="text-blue-600">परीक्षा तैयारी ऐप</span>
          </h1>
          <p className="text-base sm:text-lg text-gray-500 mt-2">
            {board.fullName}
          </p>
          <p className="text-lg sm:text-xl text-gray-700 mt-4 max-w-2xl mx-auto">
            {board.classes} के लिए हिंदी में 20,000+ video lectures, कुंजी
            AI doubt solving, और daily quizzes।
          </p>
          <div className="mt-8 flex flex-col items-center gap-4">
            <PhoneCaptureForm source={heroSource} campaign={campaign} />
            <div className="flex flex-col sm:flex-row sm:items-center gap-3">
              <span className="text-xs text-gray-500">
                या सीधे install करें:
              </span>
              <PlayStoreCTA href={heroPlayUrl} />
            </div>
          </div>
        </div>
      </section>

      <TrustStrip />
      <StatsBlock />
      <ScreenshotCarousel />

      {/* Subjects (board-specific) */}
      <section className="py-12 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8">
            {board.shortCode} के सभी विषय
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {board.subjects.map((subject) => (
              <div
                key={subject}
                className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-center font-semibold text-gray-800"
              >
                {subject}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why this board (board-specific) */}
      <section className="py-12 px-4 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8">
            {board.shortCode} students के लिए क्यों Pathyacharya?
          </h2>
          <div className="space-y-3">
            {board.highlights.map((highlight) => (
              <div
                key={highlight}
                className="bg-white rounded-lg p-5 shadow-sm border border-gray-100 flex items-start gap-3"
              >
                <span className="text-green-500 text-xl font-bold mt-0.5">
                  ✓
                </span>
                <p className="text-lg text-gray-700">{highlight}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <KunjiHighlight />
      <PricingBlock medium="board_page" campaign={campaign} />
      <TopperGrid />
      <FAQ />

      {/* Final CTA */}
      <section className="py-14 px-4 bg-blue-600 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold mb-3">
            {board.name} परीक्षा की तैयारी अभी शुरू करें
          </h2>
          <p className="text-lg mb-6 text-blue-100">
            7 दिन का free trial — पसंद आए तभी subscribe करें।
          </p>
          <div className="flex justify-center mb-6">
            <PhoneCaptureForm
              source={finalSource}
              campaign={campaign}
              ctaLabel="मुझे call back करें"
              successLabel="Done — हमारी टीम जल्द call करेगी।"
              helperLabel="हम call करके guide करेंगे, spam नहीं भेजेंगे।"
            />
          </div>
          <div className="text-blue-100 text-sm mb-3">— या —</div>
          <a
            href={finalPlayUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-blue-600 font-bold text-lg px-8 py-4 rounded-xl hover:bg-gray-100 transition-colors"
          >
            अभी Download करें
          </a>
        </div>
      </section>
    </div>
  );
};

export { boardData };
export default BoardPage;
